const appendUploadFile = (files, file, maxCount) => {
    const currentFiles = Array.isArray(files) ? files : [];
    const limit = Number.isInteger(maxCount) && maxCount > 0 ? maxCount : Infinity;
    if (!file || currentFiles.length >= limit) return currentFiles;
    return currentFiles.concat(file);
};

const removeUploadFile = (files, index) => {
    const currentFiles = Array.isArray(files) ? files : [];
    if (!Number.isInteger(index) || index < 0 || index >= currentFiles.length) return currentFiles;
    return currentFiles.slice(0, index).concat(currentFiles.slice(index + 1));
};

module.exports = {
    appendUploadFile,
    removeUploadFile,
};
